import { useEffect } from 'react'
import { Button } from '@helix-ds/react'
import { Close, InfoCircle } from 'flowbite-react-icons/outline'
import { RESTART_ORDER_TITLE } from './restartOrderCopy'

export interface RestartOrderStatusModalProps {
  isOpen: boolean
  message: string
  onClose: () => void
}

export function RestartOrderStatusModal({
  isOpen,
  message,
  onClose,
}: RestartOrderStatusModalProps) {
  useEffect(() => {
    if (!isOpen) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-60 flex items-center justify-center px-4 py-6">
      <button
        type="button"
        aria-label="Close dialog"
        onClick={onClose}
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
      />
      <div
        className="relative w-full max-w-md rounded-base border border-border-base bg-white p-6 shadow-lg dark:border-gray-700 dark:bg-gray-900"
        role="dialog"
        aria-modal="true"
        aria-labelledby="restart-order-status-title"
      >
        <Button
          type="button"
          variant="ghost"
          size="sm"
          aria-label="Close"
          onClick={onClose}
          icon={<Close className="h-4 w-4" />}
          className="absolute right-3 top-3 !p-2"
        />

        <div className="flex flex-col items-center gap-4 pt-1 text-center">
          <InfoCircle className="h-10 w-10 text-brand-600 dark:text-brand-400" aria-hidden />
          <div>
            <h2
              id="restart-order-status-title"
              className="text-lg font-semibold tracking-tight text-text-heading dark:text-white"
            >
              {RESTART_ORDER_TITLE}
            </h2>
            <p className="mt-1 text-sm font-medium text-text-body dark:text-gray-400">
              {message}
            </p>
          </div>
          <Button type="button" variant="primary" size="md" onClick={onClose}>
            OK
          </Button>
        </div>
      </div>
    </div>
  )
}
